/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RatesRouteImport } from './routes/rates'
import { Route as OpportunitiesRouteImport } from './routes/opportunities'
import { Route as IndexRouteImport } from './routes/index'

const RatesRoute = RatesRouteImport.update({
  id: '/rates',
  path: '/rates',
  getParentRoute: () => rootRouteImport,
} as any)
const OpportunitiesRoute = OpportunitiesRouteImport.update({
  id: '/opportunities',
  path: '/opportunities',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/opportunities': typeof OpportunitiesRoute
  '/rates': typeof RatesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/opportunities': typeof OpportunitiesRoute
  '/rates': typeof RatesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/opportunities': typeof OpportunitiesRoute
  '/rates': typeof RatesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/opportunities' | '/rates'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/opportunities' | '/rates'
  id: '__root__' | '/' | '/opportunities' | '/rates'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OpportunitiesRoute: typeof OpportunitiesRoute
  RatesRoute: typeof RatesRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/rates': {
      id: '/rates'
      path: '/rates'
      fullPath: '/rates'
      preLoaderRoute: typeof RatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opportunities': {
      id: '/opportunities'
      path: '/opportunities'
      fullPath: '/opportunities'
      preLoaderRoute: typeof OpportunitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OpportunitiesRoute: OpportunitiesRoute,
  RatesRoute: RatesRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
